import classnames from 'classnames'
import React from 'react'
import { Callback } from 'src/common'
import { Domain, DomainStatus } from 'src/models/Domain'

import classes from './DomainChips.module.css'


interface Props {
  domain: Domain
  setAsDefault: Callback<number>
}

export const DomainChips: React.FC<Props> = ({ domain, setAsDefault }) => {
  const status = domain?.default ? 'default' : domain?.status.toLocaleLowerCase()
  const cssStatus = `status-${ status }`
  return (
    <div className={ classes['chips-wrap'] }>
      <span className={ classnames(classes.status, classes[cssStatus]) }>{ status }</span>
      <button
        className={ classnames(classes.chips, classes[cssStatus]) }
        type="button"
        onClick={ () => setAsDefault(domain.id)}
        disabled={  !(domain?.status === DomainStatus.ACTIVE && !domain?.default) }
      >
        { domain.host }
      </button>
    </div>
  )
}
